import { atom } from "jotai";

// Filter State Atoms
export const activeSlateAtom = atom(0);
export const showCompletedAtom = atom(false);
export const completedFilterAtom = atom("today");
export const slatesAtom = atom(["Work", "Personal", "Other"]);
